import { clsx } from "@/src/utils/clsx"
import React from "react"

interface GridProps extends React.HTMLAttributes<HTMLDivElement> {
    desktopColumns: number
    mobileColumns: number
    children: React.ReactNode
    className?: string
}

interface ColumnClasses {
    [key: number]: string
}

export default function Grid({
    desktopColumns,
    mobileColumns,
    children,
    className = "",
    ...rest
}: GridProps) {
    const columnClasses: ColumnClasses = {
        1: "grid-cols-1",
        2: "grid-cols-2",
        3: "grid-cols-3",
        4: "grid-cols-4",
        5: "grid-cols-5",
        6: "grid-cols-6",
        7: "grid-cols-7",
        8: "grid-cols-8",
        9: "grid-cols-9",
        10: "grid-cols-10",
        11: "grid-cols-11",
        12: "grid-cols-12"
    }

    const gridClasses = clsx(
        `grid ${columnClasses[mobileColumns]} md:${columnClasses[desktopColumns]}`,
        className
    )

    return (
        <div className={gridClasses} {...rest}>
            {children}
        </div>
    )
}
